import { modalType } from 'util/modalType';

export const isEditModalOpen = ({ modal, isCollapsed }) => modal === modalType.EDIT && !isCollapsed;

export const isCollapsedEditModalOpen = ({ modal, isCollapsed }) =>
  modal === modalType.EDIT && isCollapsed;
